import { create } from 'zustand';

import { type AuthMeResponse } from '@irl/types';

interface AuthState {
  token: string | null;
  user: AuthMeResponse['user'] | null;
  chats: AuthMeResponse['chats'];
  isGlobalOperator: boolean;
  isAuthReady: boolean;
  setToken: (token: string) => void;
  setSession: (session: AuthMeResponse) => void;
  setAuthReady: (ready: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  user: null,
  chats: [],
  isGlobalOperator: false,
  isAuthReady: false,
  setToken: (token) => {
    set({ token });
  },
  setSession: (session) => {
    set({
      user: session.user,
      chats: session.chats,
      isGlobalOperator: session.isGlobalOperator,
      isAuthReady: true,
    });
  },
  setAuthReady: (ready) => {
    set({ isAuthReady: ready });
  },
  logout: () => {
    set({
      token: null,
      user: null,
      chats: [],
      isGlobalOperator: false,
      isAuthReady: false,
    });
  },
}));
